// This file is automatically generated. Do not edit manually.

import { Reclamation } from "src/api/generated/erp/db/types/tables/reclamation";
import { ErpAppUser } from "src/api/generated/erp/db/types/tables/erpAppUser";
import { ReclamationCategory } from "src/api/generated/erp/db/types/tables/reclamationCategory";
import { ReclamationHandlingMethod } from "src/api/generated/erp/db/types/tables/reclamationHandlingMethod";
import { ReclamationLocation } from "src/api/generated/erp/db/types/tables/reclamationLocation";
import { AppUser } from "src/api/generated/postgres/db/types/role_management/tables/appUser";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ReclamationQueryApi {
	export async function getReclamationOptions(args: {
		currentSelection: number | null | undefined;
		searchQuery: string;
		notConnectedToCustomerOrderId?: number | null | undefined;
		notConnectedToAnyReclamationRound?: boolean;
		siteId?: number | null | undefined;
		limit?: number;
		includeClosed?: boolean;
	}): Promise<Array<Reclamation>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/getReclamationsOptions",
			method: "POST",
			data: {
				currentSelection: args.currentSelection,
				searchQuery: args.searchQuery,
				notConnectedToCustomerOrderId: args.notConnectedToCustomerOrderId,
				notConnectedToAnyReclamationRound: args.notConnectedToAnyReclamationRound,
				siteId: args.siteId,
				limit: args.limit,
				includeClosed: args.includeClosed,
			},
		});
		return response as Array<Reclamation>;
	}

	export async function getResponsiblePersonOptions(): Promise<Array<ErpAppUser>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/getResponsiblePersonOptions",
			method: "POST",
			data: {},
		});
		return response as Array<ErpAppUser>;
	}

	export async function getReclamationCategoryOptions(): Promise<Array<ReclamationCategory>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/getReclamationCategoryOptions",
			method: "POST",
			data: {},
		});
		return response as Array<ReclamationCategory>;
	}

	export async function getReclamationHandlingMethodOptions(): Promise<Array<ReclamationHandlingMethod>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/getReclamationHandlingMethodOptions",
			method: "POST",
			data: {},
		});
		return response as Array<ReclamationHandlingMethod>;
	}

	export async function getReclamationLocationOptions(): Promise<Array<ReclamationLocation>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/getReclamationLocationOptions",
			method: "POST",
			data: {},
		});
		return response as Array<ReclamationLocation>;
	}

	export async function getWorkerUserOptions(args: {
		currentSelection: number | null | undefined;
		searchQuery: string;
	}): Promise<Array<AppUser>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/getWorkerUserOptions",
			method: "POST",
			data: {
				currentSelection: args.currentSelection,
				searchQuery: args.searchQuery,
			},
		});
		return response as Array<AppUser>;
	}
}
